/*
 * @Author: 赵泽文
 * @Date: 2022-05-05 09:36:34
 * @LastEditors: 陈力恒
 * @LastEditTime: 2022-05-17 20:45:38
 * @Description: 调整单数据存储
 */

import type {
  IAdjustmentOrderModel,
  IAdjustmentOrderStore,
} from '@monorepo/types/check/adjustmentOrder/adjustmentOrder.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IAdjustmentOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  auditNo: '',
};

const adjustmentOrderStore: IAdjustmentOrderModel = {
  namespace: 'adjustmentOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default adjustmentOrderStore;
